import { indexData, createData } from '../redux/contactMethods/mock';
import { isTestEnvironment } from '../util/environment';

export default function () {
  if (isTestEnvironment()) {
    this.get('/api/v1/users/ABCDEFG/contact_methods', this.passthrough);
    this.post('/api/v1/users/ABCDEFG/contact_methods', this.passthrough);
    return;
  }

  const responseHeaders = { 'Content-Type': 'application/json' };

  this.get('/api/v1/users/:id/contact_methods', () => [200, responseHeaders, JSON.stringify(indexData())]);

  this.post('/api/v1/users/:user_id/contact_methods', ({ params, requestBody }) => {
    const responseBody = createData(params.user_id, JSON.parse(requestBody));
    return [201, responseHeaders, JSON.stringify({ contact_method: responseBody })];
  });
}
